import { Route, Routes } from "react-router-dom";

import {
  NotFoundPage,
  SurveyPageSexualHarassment,
  SurveyPageWorkplaceHarassment,
  SurveyFinalThankYou,
} from "./pages";
import { GenderlabHeader } from "./components/GenderlabHeader";
import { Divider } from "@mantine/core";

export default function App() {
  return (
    <>
      <GenderlabHeader />
      <Routes>
        <Route path="*" element={<NotFoundPage />} />

        {/* Disabled demo preview routes (legacy links shared externally) */}
        <Route path="sexual-harassment/preview" element={<NotFoundPage />} />
        <Route
          path="workplace-harassment/preview"
          element={<NotFoundPage />}
        />

        {/* Sexual Harassment Survey Routes */}
        <Route
          path=":id"
          element={
            <SurveyPageSexualHarassment isPreview={false} isDemoMode={false} />
          }
        />
        <Route
          path="preview/:id"
          element={
            <SurveyPageSexualHarassment isPreview={true} isDemoMode={false} />
          }
        />
        <Route
          path="demo/sexual-harassment/:id"
          element={
            <SurveyPageSexualHarassment isPreview={true} isDemoMode={true} />
          }
        />

        {/* Workplace Harassment Survey Routes */}
        <Route
          path="workplace-harassment/:id"
          element={
            <SurveyPageWorkplaceHarassment
              isPreview={false}
              isDemoMode={false}
            />
          }
        />
        <Route
          path="workplace-harassment/preview/:id"
          element={
            <SurveyPageWorkplaceHarassment
              isPreview={true}
              isDemoMode={false}
            />
          }
        />
        <Route
          path="demo/workplace-harassment/:id"
          element={
            <SurveyPageWorkplaceHarassment
              isPreview={true}
              isDemoMode={true}
            />
          }
        />
        <Route path="/thank-you" element={<SurveyFinalThankYou />} />
      </Routes>
      <Divider mt="xl" />
    </>
  );
}
